import { makeStyles, Divider, Typography } from "@material-ui/core";


const usePlatformStyles = makeStyles((theme) => ({
     Wrapper :{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        marginBlock: "32px",
      },
      
      LinksWrapper :{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: "16px",
      },
      
      SocialWrapper :{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: "24px",
      },
      
      VerticalDivider :{
        width: "1px",
        height: "24px",
        backgroundColor: "#C6C6C6",
      },
      
      FooterLink :{
        fontSize: "16px",
        fontWeight: 600,
        lineHeight: "1.5rem",
        textDecoration: "none",
        color: "#6050AE",
      },

      YearLabel: {
        fontSize: "14px",
        fontWeight: 400,   
        color: "#48464A",
      }
    }))

const PlatformFooter = () => {
 
    const platformClasses = usePlatformStyles();
    const platformBaseUrl = process.env.REACT_APP_PLATFORM_URL;

    return (
        <>
            <Divider style={{ marginTop: "32px" }} />
            <div className={platformClasses.Wrapper}>
                <div className={platformClasses.LinksWrapper}>
                    <a href={`${platformBaseUrl}/trust-centre`} className={platformClasses.FooterLink}>
                        Trust Centre
                    </a>
                    <div className={platformClasses.VerticalDivider} />
                    <a href={`${platformBaseUrl}/trust-centre/privacy-notice`} className={platformClasses.FooterLink}>
                        Privacy Notice
                    </a>
                </div>
                <div className={platformClasses.SocialWrapper}>
                    <a
                        href="https://www.facebook.com/WorkNestGroup"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img src="/Facebook.svg" alt="Facebook" />
                    </a>
                    <a
                        href="https://x.com/WorkNestGroup"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img src="/X.svg" alt="X" />
                    </a>
                    <a
                        href="https://www.linkedin.com/company/worknestgroup"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img src="/LinkedIn.svg" alt="LinkedIn" />
                    </a>
                </div>
            </div>
            <Typography className={platformClasses.YearLabel}>
                &copy; {new Date().getFullYear()} WorkNest. All rights reserved.
            </Typography>                  
    </>
    );
};

export default PlatformFooter;
